/**
 * "4대 측정" 순차 진행 상태 관리
 * localStorage에 진행 상태를 저장하고,
 * 각 측정 페이지 종료 후 /measureSelect로 복귀하면 다음 측정으로 자동 이동한다.
 */
const STORAGE_KEY = 'measure-all-progress'

const MeasureAllHelper = {
    // 순차 측정 순서 및 처방(prescription) 완료 플래그 매핑
    steps: [
        { measureType: 'eeg',             name: 'EEG 측정',       shortName: 'EEG',             doneKey: 'isEEG',             requestKey: 'eeg',             requestIDKey: 'eegRequestID' },
        { measureType: 'balance',         name: '균형상태 측정',   shortName: '균형상태',         doneKey: 'isBalance',         requestKey: 'default',         requestIDKey: 'defaultRequestID' },
        { measureType: 'meditationTest',  name: '뇌기능 의식패턴', shortName: '뇌기능 의식패턴',  doneKey: 'isBrainActive',     requestKey: 'meditation',      requestIDKey: 'meditationRequestID' },
        { measureType: 'measureBandTest', name: '항상성 자기조절', shortName: '항상성 자기조절',  doneKey: 'isMeasureBandTest', requestKey: 'measureBandTest', requestIDKey: 'measureBandTestRequestID' },
    ],

    getMeasureUrl(measureType, prescriptionID, requestID) {
        const rqs = requestID || ''
        switch (measureType) {
            case 'eeg':
                return `/measureBand/${prescriptionID}?rqs=${rqs}`
            case 'balance':
                return `/measure/${prescriptionID}?rqs=${rqs}`
            case 'meditationTest':
                return `/exercise/meditationTest/${prescriptionID}?rqs=${rqs}`
            case 'measureBandTest':
                return `/exercise/measureBandTest/${prescriptionID}?rqs=${rqs}`
            default:
                return null
        }
    },

    start(prescriptionID) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            prescriptionID: prescriptionID,
            current: null,
        }))
    },

    get() {
        try {
            const raw = localStorage.getItem(STORAGE_KEY)
            return raw ? JSON.parse(raw) : null
        } catch (e) {
            return null
        }
    },

    isActive(prescriptionID) {
        const state = this.get()
        if (!state) return false
        if (undefined === prescriptionID) return true
        return String(state.prescriptionID) === String(prescriptionID)
    },

    setCurrent(measureType) {
        const state = this.get()
        if (!state) return
        state.current = measureType
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
    },

    clear() {
        localStorage.removeItem(STORAGE_KEY)
    },
}

export default MeasureAllHelper
